<template>
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="From"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                            </base-input>
                        </div>
                        <div class="col-md-4">
                            <base-input label="Group By" >
                                <select class="form-control" size="large" v-model="inputGroupBy">
                                    <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputGroupBy: '',
                groupOptions: [
                    {key: '', value: '[Flat List]'},
                    {key: 'terminal_id', value: 'Terminal'},
                    {key: 'user_id', value: 'Cashier'},
                    {key: 'customer_id', value: 'Customer'}
                ],
                birSalesReports: [],
            }
        },
        computed: {
            ...mapState(['endPoint']),
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg) { 
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },
            generateReport: async function () {
                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_documents/pos_vat_exempt_sales?date_from=' + this.inputDate[0].format('YYYY-MM-DD HH:mm:ss') + 
                    '&date_to=' + this.inputDate[1].format('YYYY-MM-DD HH:mm:ss') + '&group=' + this.inputGroupBy, null)
                if(get_request.error) {
                    this.openNotificationWithIcon('error', get_request.error);
                    return
                }
                var siteSpecific = get_request;

                if(siteSpecific.length > 0){
                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal'});
                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                    var headers = [
                        [
                            {content: 'Terminal', styles: {halign: 'center'}},
                            {content: 'Trans #', styles: {halign: 'center'}},
                            {content: 'Date Time', styles: {halign: 'center'}},
                            {content: 'Customer Code', styles: {halign: 'center'}},
                            {content: 'Customer Name', styles: {halign: 'center'}},
                            {content: 'TIN', styles: {halign: 'center'}},
                            {content: 'Trans Amount', styles: {halign: 'center'}},
                            {content: 'Amount Net\nVatable', styles: {halign: 'center'}},
                            {content: 'Amount Net\nNonVat', styles: {halign: 'center'}},
                            {content: 'Amount Vat\nExempt', styles: {halign: 'center'}}
                        ]
                    ];

                    for(var x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        if(this.birSalesReports.length > 0){
                            let grouper = '';

                            let subtotal_trans_amount = 0
                            let subtotal_amount_net_vat = 0
                            let subtotal_amount_net_non_vat = 0
                            let subtotal_amount_tax_exempt = 0

                            let grandtotal_trans_amount = 0
                            let grandtotal_amount_net_vat = 0
                            let grandtotal_amount_net_non_vat = 0
                            let grandtotal_amount_tax_exempt = 0

                            let reportData = [];
                            for(var i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let detail = []
                                
                                if(this.inputGroupBy == 'user_id'){
                                    if(grouper == ''){
                                        let detail_header = ["Cashier :", reportLine.cashier_name]
                                        reportData.push(Object.assign({}, detail_header))
                                    } else {
                                        if(grouper != reportLine.user_id){
                                            let detail_header = ['Cashier :', reportLine.cashier_name];
                                            reportData.push(Object.assign({}, detail_header))
                                        }
                                    }
                                    grouper = reportLine.user_id
                                }

                                detail = [
                                    reportLine.terminal_name, 
                                    reportLine.trans_id,
                                    moment(reportLine.document_date).format('MM/DD/YYYY hh:mm a'),
                                    reportLine.customer_code,
                                    reportLine.customer_name,
                                    reportLine.customer_tin,
                                    this.convertToCurrency(Number(reportLine.trans_amount)),
                                    this.convertToCurrency(Number(reportLine.amount_net_vat)),
                                    this.convertToCurrency(Number(reportLine.amount_net_non_vat)),
                                    this.convertToCurrency(Number(reportLine.amount_tax_exempt))
                                ]
                                reportData.push(Object.assign({}, detail))

                                if(this.inputGroupBy != ''){
                                    subtotal_trans_amount += Number(reportLine.trans_amount)
                                    subtotal_amount_net_vat += Number(reportLine.amount_net_vat)
                                    subtotal_amount_net_non_vat += Number(reportLine.amount_net_non_vat)
                                    subtotal_amount_tax_exempt += Number(reportLine.amount_tax_exempt)
                                }

                                grandtotal_trans_amount += Number(reportLine.trans_amount)
                                grandtotal_amount_net_vat += Number(reportLine.amount_net_vat)
                                grandtotal_amount_net_non_vat += Number(reportLine.amount_net_non_vat)
                                grandtotal_amount_tax_exempt += Number(reportLine.amount_tax_exempt)

                                if(i == this.birSalesReports.length - 1){

                                    if(this.inputGroupBy != ''){
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        let sub_detail = ["", "", "", "", "", "Total :",
                                            this.convertToCurrency(subtotal_trans_amount),
                                            this.convertToCurrency(subtotal_amount_net_vat),
                                            this.convertToCurrency(subtotal_amount_net_non_vat),
                                            this.convertToCurrency(subtotal_amount_tax_exempt)
                                        ]
                                        reportData.push(Object.assign({}, sub_detail))
                                    }

                                    let grand_detail = ["", "", "", "", "", "Grand Total :",
                                        this.convertToCurrency(grandtotal_trans_amount),
                                        this.convertToCurrency(grandtotal_amount_net_vat),
                                        this.convertToCurrency(grandtotal_amount_net_non_vat),
                                        this.convertToCurrency(grandtotal_amount_tax_exempt)
                                    ]
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, grand_detail))
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    if(this.inputGroupBy == 'terminal_id'){
                                        current_grouper = reportLine.terminal_id
                                        next_grouper = this.birSalesReports[i+1].terminal_id
                                    } else if(this.inputGroupBy == 'user_id'){
                                        current_grouper = reportLine.user_id
                                        next_grouper = this.birSalesReports[i+1].user_id
                                    } else if(this.inputGroupBy == 'customer_id'){
                                        if(reportLine.customer_id == 0){
                                            if(reportLine.customer_code == ''){
                                                current_grouper = reportLine.customer_name
                                                next_grouper = this.birSalesReports[i+1].customer_name
                                            } else {
                                                current_grouper = reportLine.customer_code
                                                next_grouper = this.birSalesReports[i+1].customer_code
                                            }
                                        } else {
                                            current_grouper = reportLine.customer_id
                                            next_grouper = this.birSalesReports[i+1].customer_id
                                        }
                                    }

                                    if(current_grouper != next_grouper){
                                        if(this.inputGroupBy != ''){
                                            let sub_detail = ["", "", "", "", "", "Total :",
                                                this.convertToCurrency(subtotal_trans_amount),
                                                this.convertToCurrency(subtotal_amount_net_vat),
                                                this.convertToCurrency(subtotal_amount_net_non_vat),
                                                this.convertToCurrency(subtotal_amount_tax_exempt)
                                            ]
                                            reportData.push(Object.assign({}, ["rowLine"]))
                                            reportData.push(Object.assign({}, sub_detail))

                                            subtotal_trans_amount = 0
                                            subtotal_amount_net_vat = 0
                                            subtotal_amount_net_non_vat = 0
                                            subtotal_amount_tax_exempt = 0
                                        }
                                    }
                                }
                                
                            }

                            let group_text = ""
                            if(this.inputGroupBy == 'terminal_id'){
                                group_text = ' by Terminal'
                            } else if(this.inputGroupBy == 'user_id'){
                                group_text = ' by Cashier'
                            } else if(this.inputGroupBy == 'customer_id'){
                                group_text = ' by Customer'
                            }

                            doc.setFontSize(14);
                            doc.setFontType("bold");

                            doc.text(15,20,"POS Vat Exempt Sales" + group_text)
                            doc.setFontType("normal");
                            doc.setFontSize(10);
                            
                            doc.text(340,20,siteSpecific[x].report_details[0].site_name, "right")
                            doc.text(15,25,"As of " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))

                            doc.autoTable({
                                startY: 30, 
                                head: headers, 
                                body: reportData, 
                                theme: 'plain',
                                tableWidth: 'wrap',
                                headStyles: {
                                    lineWidth: 0.15,
                                    cellPadding: 2
                                },
                                styles: {
                                    cellPadding: 1.0, fontSize: 9,
                                    halign: 'right'
                                },
                                columnStyles: {
                                    0: {cellWidth: 30},
                                    1: {cellWidth: 30},
                                    2: {cellWidth: 35},
                                    3: {cellWidth: 30},
                                    4: {cellWidth: 50},
                                    5: {cellWidth: 30},
                                    6: {cellWidth: 30},
                                    7: {cellWidth: 30},
                                    8: {cellWidth: 30},
                                    9: {cellWidth: 30}
                                },
                                didParseCell: function(data) {
                                    if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                        data.cell.styles.fillColor = [0, 0, 0]
                                        data.cell.styles.fontSize = 1
                                        data.cell.styles.cellPadding = 0
                                    } else if (data.row.section == 'body' && (data.row.raw[5] == 'Total :' && data.row.raw[5] == 'Grand Total :')){
                                        data.cell.styles.fontStyle = 'bold'
                                    }
                                }
                            });

                            doc.text(15,205,"Printed By: " + secureStorage.getItem("email"))
                            doc.text(340,205,"POS Vat Exempt Sales" + group_text, "right")
                            doc.text(15,210,"Print Date: " + moment().format("MM/DD/YYYY h:mm:ssA"))
                            doc.text(340,210,"Page " + ( x + 1)  + " of " + siteSpecific.length, "right")
                        }
                    }

                    //doc.save(`POS_Vat_Exempt_Sales_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                }
            }
        }
    };
</script>

<style></style>